import React, { useContext, useEffect, useState, Suspense } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import Footer from "./components/ActoLoan/Footer";
import DashboardHeader from "./components/DashboardHeader/DashboardHeader";
import SideBar from "./components/Sidebar/SideBar";
import { getStorage, isEmpty } from "./Utils/common";
import LoanLayoutContext from "./LoanLayoutContext";

import "./css/Dashboard_New.css";

function LoanLayout() {
  const [sideBar, setSideBar] = useState(false);
  const [login, setLogin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setSideBar(true); // Closed on mobile by default
      } else {
        setSideBar(false); // Open on desktop by default
      }
    };

    // Run initially
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const checklogin = getStorage("token");
  useEffect(() => {
    if (!isEmpty(checklogin)) {
      setLogin(true);
    } else {
      navigate('/apply-now');
    }
  }, [checklogin, navigate]);

  if (login) {
    return (
      <LoanLayoutContext>
        <div className="dashboard_main_wrapper">
          <div id="snackbar"></div>
          
          <SideBar toggle={sideBar} setToggle={setSideBar} />

          {/* --- Executive Mobile Overlay --- */}
          <AnimatePresence>
            {!sideBar && window.innerWidth <= 1024 && (
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setSideBar(true)}
                style={{
                  position: 'fixed',
                  inset: 0,
                  background: 'rgba(0,0,0,0.4)',
                  backdropFilter: 'blur(10px)',
                  zIndex: 998,
                  cursor: 'pointer'
                }}
              />
            )}
          </AnimatePresence>

          <div className="dashboard_view_stack">
            <DashboardHeader toggle={sideBar} setToggle={setSideBar} />
            
            <motion.main 
              className={`dashboard_content_canvas ${sideBar ? "full" : ""}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
              <Suspense fallback={<div className="loading-fallback-bar" />}>
                <Outlet />
              </Suspense>
            </motion.main>

            <footer className={`dashboard_footer_wrap ${sideBar ? "full" : ""}`}>
              <Footer />
            </footer>
          </div>
        </div>
      </LoanLayoutContext>
    );
  }

  return null;
}

export default LoanLayout;
